import React, { useEffect, useState } from 'react';
import {
    Button,
    FlexDirectionRow,
    FormContainer,
    FormInputContainer,
    MainContent,
    SubTitle,
} from '../../../../../components/StyledComponents';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { BaSeDialogContext } from '@base/react';
import {
    maxLength,
    minLength, notEmptyItem,
    valueIsRequired,
} from '../../../../../utils/regex';
import Input from '../../../../../components/InputControlled';
import { useFieldArray, useForm } from 'react-hook-form';
import Select from '../../../../../components/Select';
import { useApp } from '../../../../../context/app';
import { Box, Chip, Stack, Tooltip } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BsPlusCircle } from 'react-icons/bs';
import './styles.module.scss';
import { CanaisDigitaisService } from '../../../services/canaisDigitais';
const theme = createTheme({
    components: {
        MuiChip: {
            styleOverrides: {
                deleteIcon: {
                    color: 'red',
                    '&:hover': {
                        color: 'red',
                    },
                },
            },
        },
    },
});

export const IncluirCanaisDigitais = () => {

    const [availableUFs, setAvailableUFs] = useState([]);
    const [ufResponse, setUfResponse] = useState([]);
    const {setRenderIncludeScreen} = useApp();
    const {formState: {isValid, errors}, control, handleSubmit, reset, watch} = useForm({
        defaultValues: {
            descricao: '',
            uf: '',
            ufs: [],
        },
    });

    const {
        fields,
        append: appendUf,
        remove: removeUf,
    } = useFieldArray({
        control,
        name: 'ufs',
        rules: {
            validate: (value) => value.length > 0 ? undefined : 'Selecione pelo menos uma UF'
        },
    });

    const selectedUf = watch('uf');


    const handleFetchUfs = async () => {
        await CanaisDigitaisService.findUfs().then((resp) => {
            const tranformedResponse = resp
                .map((uf) => uf.sigla)
            setUfResponse(resp);
            setAvailableUFs(tranformedResponse);
        });
    };
    const isUfAlreadyAdded = fields.some((field) => field.sigla === selectedUf);

    const handleAddNewUf = () => {
        if (selectedUf && !isUfAlreadyAdded) {
            appendUf({sigla: selectedUf});
        }
    };

    const {showModal} = React.useContext(BaSeDialogContext);

    const handleGoHome = () => {
        setRenderIncludeScreen(false);
    };

    useEffect(() => {
        handleFetchUfs();
    }, []);

    const sendRequest = async (dataForm) => {

        if (!isValid || errors.length) {
            return;
        }



        const ufsSelected = dataForm.ufs.map((uf) => {
            return ufResponse.find((availableUf) => availableUf.sigla === uf.sigla);
        });

        try {
            const body = {
                descricao: dataForm.descricao,
                ufs: ufsSelected,
                status: 'PENDENTE',
            };
            await CanaisDigitaisService.save(body).then(() => {
                handleModalStatus({
                    type: 'success',
                    msgOnSuccess: 'Canal digital adicionado com sucesso.',
                    onCloseModal: handleGoHome,
                    showModal,
                });
            });
        } catch (e) {
            handleModalStatus({
                type: 'error',
                showModal,
            });
        }
    };

    const onResetFields = () => {
        reset({
            descricao: '',
            uf: '',
            ufs: [],
        });
    };

    return (
        <MainContent>
            <SubTitle>
                <h3>Incluir</h3>
            </SubTitle>

            <FormContainer
                style={{displayFlex: true, flexDirection: 'column'}}
                onSubmit={handleSubmit(sendRequest)}
            >
                <FormInputContainer>
                    <Input
                        required={true}
                        minLength={3}
                        maxLength={255}
                        name="descricao"
                        control={control}
                        rules={{...valueIsRequired(), ...maxLength(255), ...minLength(3)}}
                        placeholder={'Nome do canal digital'}
                        showMaxLengthLabel={false}
                    />
                </FormInputContainer>

                <Stack direction="row" alignItems="center" gap="0.5rem">
                    <FormInputContainer>
                        <Select
                            name="uf"
                            placeholder="UF"
                            options={availableUFs}
                            control={control}
                            rules={{...notEmptyItem()}}
                        />
                    </FormInputContainer>
                    <button
                        type={'button'}
                        style={{
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            marginTop: '1rem',
                        }}
                        onClick={handleAddNewUf}
                        disabled={isUfAlreadyAdded || !selectedUf}
                    >
                        <BsPlusCircle
                            size={20}
                            color={isUfAlreadyAdded || !selectedUf ? '#9ca2a8' : '#0061C6'}
                        />
                    </button>
                </Stack>

                <Box width="45%" display="flex" gap="0.5rem" flexWrap="wrap">
                    <ThemeProvider theme={theme}>
                        {fields.map((field, index) => (
                            <Tooltip title={field.sigla}>

                                <Chip
                                    label={field.sigla}
                                    color="primary"
                                    variant="outlined"
                                    onDelete={() => removeUf(index)}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                />
                            </Tooltip>
                        ))}
                    </ThemeProvider>
                </Box>

                <FlexDirectionRow position={'end'} style={{marginRight: '40px'}}>
                    <Button
                        type="button"
                        backgroundColor={'#9CA2A8'}
                        onClick={onResetFields}
                        style={{
                            marginRight: '20px',
                        }}
                    >
                        Limpar
                    </Button>

                    <Button disabled={(errors?.lenght)} href="#" type="submit">
                        Incluir canal digital
                    </Button>
                </FlexDirectionRow>
            </FormContainer>
        </MainContent>
    );
};
